export const getSchoolUrl = () => '/school'
